export enum UIMessageStatus {
    Default = 0,
    Waiting = 1,
    Accepted = 2,
    Error = 3,
    Tax = 4,
    Purchase = 5
}